<template>
  <div class="jd-section jd-section--locations">
    <p class="job-section__header">{{ title }}</p>
    <template v-if="isSingleAddress">
      <!-- TODO: Display map for other locations -->
      <map-link v-if="addresses[0]" :image-url="addressOnMap" :lat="addresses[0].lat" :lng="addresses[0].lng" />
      <div class="jd-section__items">
        <p v-for="address in addresses" :key="`JobLocation-${address._id}`" class="jd-section__item">
          {{ address.address }}
        </p>
      </div>
    </template>
    <template v-else-if="isMultiAddress">
      <div class="jd-section__multi">
        <p class="jd-section__item jd-section__multi--item">{{ districtsLabel }}</p>
        <more-btn class="jd-section__multi--more" :title="$t('jobDetail.showMore')" @click="showLocationOverlay()" />
      </div>
    </template>
    <p v-else>{{ $t('general.notAvailable') }}</p>
    <job-multi-location v-if="overlay === 'multi-location'" :addresses="addresses" @close="closeOverlay()" />
  </div>
</template>

<script>
import jobDetailMultiLocation from './jobDetailMultiLocation'
import MapLink from '../../map/mapLink'
import MoreButton from '../../list/moreButton'
import OverylayMixins from '../../../mixins/overlay'
import { sendJobLocationMapClickEvent } from '../../../libs/tracking/utils/event'

export default {
  components: {
    'job-multi-location': jobDetailMultiLocation,
    'map-link': MapLink,
    'more-btn': MoreButton,
  },
  computed: {
    isMultiAddress() {
      return this.addresses.length > 1
    },
    isSingleAddress() {
      return this.addresses.length === 1
    },
    locationPath() {
      return ''
    },
    title() {
      const title = this.$t('jobDetail.location')
      if (this.isMultiAddress) {
        return `${title} (${this.addresses.length})`
      }
      return title
    },
  },
  methods: {
    showLocationOverlay() {
      sendJobLocationMapClickEvent(this.$eventTracker, 'job_detail')
      this.showOverlay('multi-location')
    },
  },
  mixins: [OverylayMixins],
  props: {
    addresses: {
      default: () => [],
      type: Array,
    },
    addressOnMap: {
      default: null,
      type: String,
    },
    districtsLabel: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.map-link {
  @apply mb-3 -ml-1;
  width: calc(100% + 0.5rem);
  height: 136px;
  max-width: 600px;
}
.jd-section__multi {
  @apply flex flex-row w-full;
  @apply items-center;
}
.jd-section__multi--item {
  @apply flex-1;
  @apply mr-13 truncate;
}
.jd-section__multi--more {
  @apply flex-shrink-0;
}

@screen desktop {
  .map-link {
    @apply mb-4;
  }
}
</style>
